define('rebrush/components/checkout/advises',[
    'lodash',
    'jquery',
    'cartware_checkout',
    'cartware/components/_base',
    'cartware/jquery/bem'
], function(
    _,
    jQuery,
    CartwareCheckout,
    Component,
    BEM
) {

    return Component.create({
        blocks:	null,

        $init: function() {
            CartwareCheckout.prototype.updateProgress = _.wrap(CartwareCheckout.prototype.updateProgress, _.bind(function(fun, json) {
                fun(json);
                this.updateHeadline();
            }, this));

            this.updateHeadline();
        },

        updateHeadline: function() {
            var headlineBlock = BEM.block('page-title').filter(':first'),
                headline = headlineBlock.find('h1');

            var progressbarBlock = BEM.block('opcheckout-progress-bar'),
                currentStep = progressbarBlock.getElements('step').filter(':modifier(current)'),
                currentLabel = currentStep.find('.' + BEM.buildElementClassname('opcheckout-progress-bar', 'label'));

            headline.text(currentLabel.text());
        }
    });

});
